module.exports = __webpack_public_path__ + "static/media/thumb.928bc934.jpg";